<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="page.accountId" clearable placeholder="选择账户" class="search-item">
                    <el-option
                        v-for="item in accounts"
                        :key="item.id"
                        :label="item.number"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="page.typeId" clearable placeholder="选择类型" class="search-item">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="page.tags" clearable placeholder="选择标签" class="search-item">
                    <el-option
                        v-for="item in tags"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-input v-model="page.toName" placeholder="收付款方" class="search-item"></el-input>

                
            </el-row>
            <el-row class="search-row">
                <el-date-picker
                        type="date"
                        placeholder="开始变动日期"
                        v-model="page.timeStart"
                        class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止变动日期"
                    v-model="page.timeEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-input v-model="page.id" placeholder="流水号" class="search-item"></el-input>

                <el-button type="primary" size="small" @click="search">查询</el-button>
                
                <el-link class="search-link" type="primary" @click="getTotle">查看统计数据</el-link>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 134"
            class="finance-bill-table"
        >
            <el-table-column prop="accountName" label="所属账户" width="100"></el-table-column>

            <el-table-column prop="tagNames" label="标签" width="200">
                <template slot-scope="bill">
                    <el-tag class="bill-tags" v-for="tag in toTags(bill.row.tagNames)" :key="tag">{{tag}}</el-tag>
                </template>
            </el-table-column>


            <el-table-column prop="id" label="流水号" width="500"></el-table-column>

            <el-table-column prop="createTime" label="变动时间" width="200">
              <template slot-scope="bill">{{ $tools.timestampToTime(bill.row.createTime)}}</template>
            </el-table-column>
            <el-table-column prop="count" label="剩余金额" width="120">
               <template slot-scope="bill">{{ $tools.parsecost(bill.row.count, true)}}</template>
            </el-table-column>
            <el-table-column prop="changed" label="变动金额" width="100">
              <template slot-scope="bill">{{ $tools.parsecost(bill.row.changed, true)}}</template>
            </el-table-column>
            <el-table-column prop="type" label="变动类型" width="100">
              <template slot-scope="bill">
                    <el-tag type="success" v-if="bill.row.type == 'I'">收入</el-tag>
                    <el-tag type="danger" v-if="bill.row.type == 'O'">支出</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="toName" label="收付款方" width="300"></el-table-column>


            <el-table-column prop="remark" label="详情" width="60">
               <template slot-scope="bill">
                  <el-tooltip :content="bill.row.remark" placement="bottom" effect="light">
                      <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="page.total"
            @current-change="list"
            :current-page.sync="page.current"
            :page-size.sync="page.size"
        ></el-pagination>

      <el-drawer
            :visible.sync="showTotal"
            direction="rtl"
            :modal="false"
            :modal-append-to-body="false"
            size="800px"
            :withHeader="false"
        >
            <el-card class="box-card" style="text-align: center">
                <el-radio-group v-model="page.totalType" @change="getTotle">
                        <el-radio  label="D">按日查看</el-radio>
                        <el-radio  label="M">按月查看</el-radio>
                </el-radio-group>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tooltip placement="right" effect="light">
                        <div slot="content">1、不包含已退款、退款中的订单</div>
                        <span>支出/收入</span>
                    </el-tooltip>
                </div>
                <div id="sale"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tooltip placement="right" effect="light">
                        <div slot="content">1、只包含审核通过的支出数据</div>
                        <span>净利润({{profit}})</span>
                    </el-tooltip>
                </div>
                <div id="profit"></div>
            </el-card>

        </el-drawer>
    </div>
</template>

<script>
import { Chart, registerInteraction, registerAction, ActionConstructor, getDelegationObject} from "@antv/g2";

export default {
    data() {
        return {
            char: {sale: null, profit: null},
            showTotal: false,
            accounts: null,
            records: null,
            profit: null,
            types: [
                { id: "I", name: "收入" },
                { id: "O", name: "支出" }
            ],
            tags: [],
            page: { 
                current: null,
                total: null,
                size:10,
                totalType: 'D'
            }
        };
    },
    methods: {
        getAccount() {
          let _this = this;

          _this.$http.post(
                ["finance/account/all"],
                [
                    function (data) {
                        _this.accounts = data;
                    },
                ],
                ".finance-bill-tabnle"
            );
        },
        getTags() {
          let _this = this;

          _this.$http.post(
                ["finance/expense/type/all"],
                [
                    function (data) {
                        _this.tags = data;
                    },
                ],
                ".finance-bill-tabnle"
            );
        },
        search() {
            this.page.current = 1;
            this.list();
        },
        list() {
            let _this = this;

            _this.$http.post(
                ["finance/bill/page", _this.page],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.page.total = data.total;
                    },
                ],
                ".finance-bill-tabnle"
            );
        },
        getTotle() {
          let _this = this;

          _this.showTotal = true;

          _this.$http.post(
                ["finance/bill/total", _this.page],
                [
                    function (data) {
                            _this.profit = 0;

                            for (var i in data.bills) {
                                data.bills[i].changed = _this.$tools.parsecost(
                                    data.bills[i].changed
                                );
                            }

                            for (var i in data.profit) {
                                data.profit[i].changed = _this.$tools.parsecost(
                                    data.profit[i].changed
                                );

                                _this.profit += data.profit[i].changed;
                            }

                            _this.render("sale", data.bills, "date*changed", "type");
                            _this.render("profit", data.profit, "date*changed", "type");
                    },
                ],
                ".finance-bill-tabnle"
            );
        },
        render(name, data, position, type, action) {
            let _this = this;

            if (!this.char[name]) {
                this.char[name] = new Chart({
                    container: name,
                    autoFit: true,
                    height: 250,
                });

                if (name == "profit") {
                    this.char[name]
                        .interval()
                        .position(position)
                        .color("changed", value => {
                            return (window.parseFloat(value) >= 0 ? "green" : "red");
                        });

                    this.char[name].tooltip({
                        shared: true,
                        customContent: (name, items) => {
                            const container = document.createElement("div");
                            container.className = "g2-tooltip";

                            let html = [];
                            html.push(`<div class="g2-tooltip-title" style="margin-top: 12px;margin-bottom: 12px;">${name}</div>`);

                            let count = window.parseFloat(0);
                            items.forEach((item) => {
                                html.push(`<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;display:flex;align-items: center;">`);
                                html.push(` <span style="background-color:${item?.mappingData?.color || item?.color};" class="g2-tooltip-marker"></span>`);
                                html.push(` <span style="display:inline-flex;flex:1;justify-content:space-between">`);
                                html.push(`     <span style="margin-right: 16px;">净利润:</span><span>${item?.value}</span>`);
                                html.push(` </span>`);
                                html.push(`</li>`);
                                count += window.parseFloat(item.value);
                            });

                            container.innerHTML = html.join("");
                            return container;
                        },
                    });
                } else {
                    this.char[name]
                        .interval()
                        .position(position)
                        .color(type).adjust([
                            {
                            type: 'dodge',
                            marginRatio: 0,
                            },
                        ]);


                }

            }

            this.char[name].data(data);
            this.char[name].render();
        },
        toTags(tag) {
            return tag ? tag.split(",") : [];
        }
    },
    mounted() {
        this.getAccount();
        this.getTags();
        this.list(1);
    },
};
</script>

<style lang="scss">
.bill-tags {
    margin-right: 5px;
}
</style>